import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { IVISAxios } from "../../Modules/Axios/IVISAxios";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { uploadFileByPresignedUrl } from "./uploadFileByPresignedUrl";
import { v4 as uuidv4 } from "uuid";

const BuyerInfo = ({ vehicleData, inquiryHandler }) => {
  //최종 업로드 Axios API

  // const [type, setType] = useState(null);

  //구매자 정보 담는 state
  const [buyerData, setBuyerData] = useState({
    buyerName: vehicleData.buyerName,
    buyerCompanyName: vehicleData.buyerCompanyName,
    buyerAddress: vehicleData.buyerAddress,
    buyerPlace: vehicleData.buyerPlace,
    buyerCRN: vehicleData.buyerCRN,
    buyerSSNumber: vehicleData.buyerSSNumber,
    buyerTel: vehicleData.buyerTel,
    taxOffice: vehicleData.taxOffice,
    salesDate: vehicleData.salesDate,
    vehicleRegNo: vehicleData.vehicleRegNo,
    dg: vehicleData.dg,
    refundIssuedDate: vehicleData?.refundIssuedDate,
    ecoVehicleType: vehicleData?.ecoVehicleType || "NA",
  });

  const onChangeBuyerName = (e) => {
    setBuyerData((prevState) => ({ ...prevState, buyerName: e.target.value }));
  };
  const onChangeBuyerCompany = (e) => {
    setBuyerData((prevState) => ({
      ...prevState,
      buyerCompanyName: e.target.value,
    }));
  };

  const onChangeBuyerAddress = (e) => {
    setBuyerData((prevState) => ({
      ...prevState,
      buyerAddress: e.target.value,
    }));
  };

  const onChangeData4 = (e) => {
    setBuyerData((prevState) => ({ ...prevState, buyerPlace: e.target.value }));
  };

  const onChangeData5 = (e) => {
    setBuyerData((prevState) => ({ ...prevState, buyerCRN: e.target.value }));
  };

  const onChangeData6 = (e) => {
    setBuyerData((prevState) => ({
      ...prevState,
      buyerSSNumber: e.target.value,
    }));
  };

  const onChangeData7 = (e) => {
    setBuyerData((prevState) => ({ ...prevState, buyerTel: e.target.value }));
  };

  const onChangeData9 = (e) => {
    setBuyerData((prevState) => ({
      ...prevState,
      vehicleRegNo: e.target.value,
    }));
  };
  const onChangetaxOffice = (e) => {
    setBuyerData((prevState) => ({
      ...prevState,
      taxOffice: e.target.value,
    }));
  };

  const onChangeTaxInvoiceIssueDate = (e) => {
    setBuyerData((prevState) => ({
      ...prevState,
      refundIssuedDate: e.target.value,
    }));
  };

  const onChangeEcoVehicleType = (e) => {
    setBuyerData((prevState) => ({
      ...prevState,
      ecoVehicleType: e.target.value,
    }));
  };

  const applicationHandler = async (e) => {
    try {
      const result = await IVISAxios.patch(
        "/buyer",
        new URLSearchParams({
          vin: vehicleData.vin,
          buyer: JSON.stringify({ ...buyerData, buyerSignImageLink: fileKey }),
        })
      );
      alert("신청이 완료되었습니다.");
      inquiryHandler();
    } catch (error) {
      console.error(error);
    }
  };

  //신고자 정보 가져오는 핸들러 InquiryHandler에서 vehicle에조회! 동시조회 예정
  const getHandler = async (e) => {
    try {
      const result = await IVISAxios.get("/", {
        params: {
          vin: vehicleData.vinNo,
        },
      });
      setBuyerData(result.data);
    } catch (e) {
      console.error(e);
    }
  };

  const dg = ["1", "2", "3", "정도가 심한", "국가유공자", "고엽제"];

  const [hasSignImage, setHasSignImage] = useState(false);

  useEffect(() => {
    if (vehicleData?.buyerSignImageLink) {
      setHasSignImage(true);
    }
  }, [vehicleData?.buyerSignImageLink]);

  const [fileKey, setFileKey] = useState();

  const handleFileUpload = async (e) => {
    const selectedFile = e.target.files[0];
    const fileName = selectedFile.name.split(".")[0];
    const blob = await convertImageFormat(selectedFile, "image/png");
    const newFile = new File([blob], `${fileName}.png`, {
      type: blob.type,
    });
    const id = uuidv4();
    const extension = newFile.name.split(".").pop();
    const key = `aged-vehicle/${id}.${extension}`;
    const isUploaded = await uploadFileByPresignedUrl(newFile, key);
    if (!isUploaded) {
      alert("파일 업로드에 실패했습니다. 다시 시도해 주세요.");
      return;
    }
    setFileKey(key);
  };

  const convertImageFormat = async (file, outputType) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        if (!ctx) return reject(new Error("Canvas not supported"));
        ctx.drawImage(img, 0, 0);
        canvas.toBlob(
          (blob) => {
            if (blob) resolve(blob);
            else reject(new Error("Conversion failed"));
          },
          outputType,
          0.9
        );
      };
      img.onerror = reject;
      img.src = URL.createObjectURL(file);
    });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: 1, gap: 2 }}>
      {/* <Autocomplete
          value={type}
          onChange={(event, newValue) => {
            setType(newValue);
            if (type !== "장애인") {
              dgreset();
            }
          }}
          disablePortal
          options={typelist}
          sx={{ width: 300 }}
          renderInput={(params) => <TextField {...params} label="정보타입선택" />}
        /> */}
      {/* {type ? ( */}
      <Grid container spacing={1}>
        {vehicleData.type === "장애인" && (
          <Grid item xs={12} sm={6}>
            <Autocomplete
              value={buyerData.dg}
              onChange={(event, newValue) => {
                setBuyerData((prevState) => ({
                  ...prevState,
                  dg: newValue,
                }));
              }}
              disablePortal
              options={dg}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField {...params} label="장애등급" />
              )}
            />
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <TextField
            label={vehicleData.type === "렌터카" ? "대표자명" : "신청인"}
            onChange={onChangeBuyerName}
            value={buyerData.buyerName}
            sx={{ width: 1 }}
          />
        </Grid>
        {(vehicleData.type === "렌터카" || vehicleData.type === "노후차") && (
          <Grid item xs={12} sm={6}>
            <TextField
              label="회사명"
              onChange={onChangeBuyerCompany}
              value={buyerData.buyerCompanyName}
              sx={{ width: 1 }}
            />
          </Grid>
        )}
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={8}>
          <TextField
            label="주소"
            onChange={onChangeBuyerAddress}
            value={buyerData.buyerAddress}
            sx={{ width: 1 }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Box sx={{ display: "flex" }}>
            <TextField
              label="관할세무서"
              onChange={onChangetaxOffice}
              value={buyerData.taxOffice}
              sx={{ flex: 1 }}
            />
            <Typography sx={{ mx: 2, alignSelf: "center" }} variant="body1">
              세무서
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        {(vehicleData.type === "렌터카" || vehicleData.type === "노후차") && (
          <Grid item xs={12} sm={6}>
            <TextField
              label="사업자등록번호(숫자만입력)"
              onChange={onChangeData5}
              value={buyerData.buyerCRN}
              sx={{ width: 1 }}
            />
          </Grid>
        )}
        {vehicleData.type !== "렌터카" && (
          <Grid item xs={12} sm={6}>
            <TextField
              label="주민등록번호"
              onChange={onChangeData6}
              value={buyerData.buyerSSNumber}
              sx={{ width: 1 }}
            />
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          <TextField
            label="자동차등록번호"
            onChange={onChangeData9}
            value={buyerData.vehicleRegNo}
            sx={{ width: 1 }}
          />
        </Grid>

        {vehicleData.type === "노후차" && (
          <Grid item xs={12} sm={6}>
            <TextField
              label="세금계산서발급일"
              type="date"
              onChange={onChangeTaxInvoiceIssueDate}
              value={buyerData.refundIssuedDate}
              sx={{ width: 1 }}
              fullWidth
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        )}
      </Grid>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="전화번호"
            onChange={onChangeData7}
            value={buyerData.buyerTel}
            sx={{ width: 1 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="판매 · 반출장소"
            onChange={onChangeData4}
            value={buyerData.buyerPlace}
            sx={{ width: 1 }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        {/* <Grid item xs={12} sm={6}>
          <TextField
            label="자동차등록연월일"
            onChange={onChangeData8}
            value={buyerData.salesDate}
            sx={{ width: 1 }}
          />
        </Grid> */}
      </Grid>
      {vehicleData.type !== "노후차" && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <FormControl>
            <FormLabel id="demo-radio-buttons-group-label">
              친환경차 구분
            </FormLabel>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue={vehicleData.ecoVehicleType || "NA"}
              name="radio-buttons-group"
              onChange={onChangeEcoVehicleType}
            >
              <Box sx={{ display: "flex" }}>
                <FormControlLabel
                  value="HEV"
                  control={<Radio />}
                  label="하이브리드차"
                />
                <FormControlLabel
                  value="EV"
                  control={<Radio />}
                  label="전기차"
                />
                <FormControlLabel
                  value="FCEV"
                  control={<Radio />}
                  label="수소차"
                />
                <FormControlLabel
                  value="NA"
                  control={<Radio />}
                  label="미해당"
                />
              </Box>
            </RadioGroup>
          </FormControl>
        </Box>
      )}
      {vehicleData.type === "노후차" && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          {!hasSignImage ? (
            <>
              <TextField
                type="file"
                inputProps={{
                  accept: ".jpg, .jpeg, .png, .gif, .bmp",
                  onChange: handleFileUpload,
                }}
                label="신청인 서명 이미지 등록"
                InputLabelProps={{ shrink: true }}
              />
              <Box>
                <Typography variant="body2">
                  ✅ jpg, jpeg, png, gif, bmp 형식의 이미지만 등록 가능합니다.
                </Typography>
                <Typography variant="body2">
                  ✅ 서명이 <strong>이미지 중앙에 가득 차도록</strong>{" "}
                  등록해주세요.
                </Typography>
                <Typography variant="body2">
                  ❌ 이미지 전체 중 일부에만 작게 서명한 경우, 서명 이미지
                  삽입이 어색할 수 있습니다.
                </Typography>
              </Box>
            </>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              <Typography variant="body2">
                등록된 서명 이미지가 존재합니다.
              </Typography>
              <Button
                variant="outlined"
                onClick={() => {
                  setHasSignImage(false);
                }}
              >
                서명 이미지 변경
              </Button>
            </Box>
          )}
        </Box>
      )}
      <Button
        variant="contained"
        onClick={applicationHandler}
        // disabled={!type}
      >
        구매자 정보 등록
      </Button>
    </Box>
  );
};

export default BuyerInfo;
